import { IStyles } from 'app/models/specs/styles';


const applyStyles = (styles: IStyles): void => {
  document.documentElement.style.setProperty('--theme-colors-primary', styles.themeColorPrimary);
  document.documentElement.style.setProperty('--theme-colors-secondary', styles.themeColorSecondary);
  document.documentElement.style.setProperty('--theme-colors-muted', styles.themeColorMuted);
  document.documentElement.style.setProperty('--theme-colors-gradient', styles.themeColorGradient);
  document.documentElement.style.setProperty('--theme-colors-checkbox', styles.themeColorCheckbox);
  document.documentElement.style.setProperty('--theme-colors-PrimaryTransparent', styles.themeColorPrimaryTransparent);
  document.documentElement.style.setProperty('--theme-colors-SecondaryTransparent', styles.themeColorSecondaryTransparent);


  document.documentElement.style.setProperty('--theme-text-color-primary', styles.themeTextColorPrimary);
  document.documentElement.style.setProperty('--theme-text-color-secondary', styles.themeTextColorSecondary);
  document.documentElement.style.setProperty('--theme-text-color-error', styles.themeTextColorError);

  document.documentElement.style.setProperty('--theme-card-borderRadius', styles.themeCardBorderRadius);
  document.documentElement.style.setProperty('--theme-card-padding', styles.themeCardPadding);

  document.documentElement.style.setProperty('--theme-max-size-width', styles.maxSizeWidth);
  document.documentElement.style.setProperty('--theme-toolbar-height', styles.toolbarHeight);
  document.documentElement.style.setProperty('--theme-footer-height', styles.footerHeight);
};

export default applyStyles;